import TableFilterable from './filterable';

export default class TableUpdatable extends TableFilterable {

  constructor(wrapper_block_selector, lang) {

    super(wrapper_block_selector, lang);

    this._table_row_form_wrapper_selector = '.table_row_form_wrapper';
    this._table_row_form_display_button_selector = '.table_row_form_display_button';
    this._table_row_form_selector = '.table_row_form';
    this._table_row_form_submit_button_selector = '.table_row_form_submit_button';
    this._table_row_form_reset_button_selector = '.table_row_form_reset_button';
    this._const_data_block_selector = '.const_data';
    this._table_row_update_link_selector = '.update';
    this._table_row_form_header_selector = '.table_row_form_header';
    this._insert_mode_data_text_key = 'insert_mode_text';
    this._update_mode_data_text_key = 'update_mode_text';
    this._visible_mode_data_text_key = 'visible_mode_text';
    this._hidden_mode_data_text_key = 'hidden_mode_text';
  }

  get table_row_form_wrapper() {
    return this.wrapper_block.find(this._table_row_form_wrapper_selector);
  }

  get table_row_form_display_button() {
    return this.table_row_form_wrapper.find(this._table_row_form_display_button_selector);
  }

  get table_row_form() {
    return this.table_row_form_wrapper.find(this._table_row_form_selector);
  }

  get table_row_form_submit_button() {
    return this.table_row_form.find(this._table_row_form_submit_button_selector);
  }

  get table_row_form_reset_button() {
    return this.table_row_form.find(this._table_row_form_reset_button_selector);
  }

  get table_row_form_inputs() {

    var selectors = this.table_row_form_inputs_selectors_array;

    var selector_string = selectors.join(", ");

    return this.table_row_form.find(selector_string);
  }
  
  get table_row_form_inputs_selectors_array() {
    return [
      'input[type=hidden]',
      'input[type=text]',
      'input[type=number]',
      'input[type=checkbox]:checked',
      'input[type=radio]:checked',
      'select',
      'textarea'
    ];
  }

  get const_data_block() {
    return this.wrapper_block.find(this._const_data_block_selector);
  }

  get table_row_const_field_name_attr() {
    return 'data-table_row_field_name';
  }

  get table_row_const_inputs() {
    var const_inputs = this.const_data_block.find('input[type=hidden]');
    return const_inputs.filter('[' + this.table_row_const_field_name_attr + ']');
  }

  get table_row_update_links() {
    return this.table_element.find(this._table_row_update_link_selector);
  }

  get table_row_form_header() {
    return this.table_row_form.find(this._table_row_form_header_selector);
  }

  init() {
    super.init();
    this._initTableRowFormDisplayButton();
    this._initTableRowFormHeader();
    this._initTableRowFormSubmitButton();
    this._initTableRowFormResetButton();
    this._initTableRowFormDefaultValues();
  };

  _initTableLinks() {
    super._initTableLinks();
    this._initTableUpdateLinks();
  }

  _initTableRowFormDisplayButton() {

    this._saveElementHtmlToDataKey(
      this.table_row_form_display_button,
      this._hidden_mode_data_text_key
    );

    var updatable_table = this;

    this.table_row_form_display_button.click(function () {
      updatable_table.table_row_form.toggle();
      updatable_table._toggleTableRowFormDisplayButton();
    });
  };

  _saveElementHtmlToDataKey(element, data_key) {
    var element_object = $(element);
    element_object.data(data_key, element_object.html());
  }

  _restoreElementHtmlFromDataKey(element, data_key) {
    var element_object = $(element);
    var html = element_object.data(data_key);
    element_object.html(html);
  }

  _toggleTableRowFormDisplayButton() {

    var hidden_mode = this.table_row_form.css('display') === "none";

    var data_text_key = this._getDataTextKeyByHiddenMode(hidden_mode);

    this._restoreElementHtmlFromDataKey(
      this.table_row_form_display_button,
      data_text_key
    );
  }

  _getDataTextKeyByHiddenMode(hidden_mode = true) {
    return hidden_mode ?
      this._hidden_mode_data_text_key :
      this._visible_mode_data_text_key;
  }

  _initTableRowFormHeader(insert_mode = true) {
    this._initElementTextsByInsertMode(this.table_row_form_header, insert_mode);
  }

  _initElementTextsByInsertMode(element, insert_mode = true) {

    if(!this._isInsertModeDataTextKeyInitialized(element)) {
      this._saveElementHtmlToDataKey(element, this._insert_mode_data_text_key);
      return;
    }

    var data_text_key = this._getDataTextKeyByInsertMode(insert_mode);

    this._restoreElementHtmlFromDataKey(
      element,
      data_text_key
    );
  }

  _isInsertModeDataTextKeyInitialized(element) {
    return $(element).data(this._insert_mode_data_text_key) ? true : false
  }

  _getDataTextKeyByInsertMode(insert_mode = true) {
    return insert_mode ?
      this._insert_mode_data_text_key :
      this._update_mode_data_text_key;
  }

  _initTableRowFormSubmitButton() {

    this._initTableRowFormSubmitButtonText();

    var table = this;

    this.table_row_form_submit_button.click(function (event) {
      event.preventDefault();
      table._submitTableRowForm();
      return false;
    });
  };

  _initTableRowFormSubmitButtonText(insert_mode = true) {
    this._initElementTextsByInsertMode(this.table_row_form_submit_button, insert_mode);
  }

  _submitTableRowForm() {

    var table_row_form_full_data = this._buildTableRowFormFullData();
    
    var table = this;

    $.ajax({
      url: table._addFilterUrlArgs(this.table_row_form.attr('action')),
      type: 'post',
      dataType: 'json',
      data: table_row_form_full_data,
      beforeSend: function () {
        table._resetStatusMessages();
        table.table_row_form_submit_button.attr('disabled', true);
        table._addButtonLoadingSpinner(table.table_row_form_submit_button);
      },
      complete: function () {
        table.table_row_form_submit_button.attr('disabled', false);
        table._removeButtonLoadingSpinner(table.table_row_form_submit_button);
      },
      success: table._processTableRowFormSubmitResult.bind(table)
    });
  };
  
  _buildTableRowFormFullData() {
    return $.extend(
      this._getTableRowFormData(),
      this._getTableRowConstFormData()
    );
  }

  _getTableRowFormData() {
    return this._getFormInputsDataAsObject(this.table_row_form_inputs);
  };

  _getTableRowConstFormData() {
    return this._getFormInputsDataAsObject(
      this.table_row_const_inputs,
      this.table_row_const_field_name_attr
    );
  };

  _processTableRowFormSubmitResult(result) {

    if (!parseInt(result.status)) {
      this._processTableRowFormSubmitWrongResult(result);
      return;
    }

    this._processTableRowFormSubmitSuccessResult(result);
  }

  _processTableRowFormSubmitWrongResult(result) {
    this._processFormSubmitWrongResult(this.table_row_form, result);
  };

  _processTableRowFormSubmitSuccessResult(result) {
    this._resetTableRowForm();
    this._reinitDynamicBlock(result.html);
  }

  _resetTableRowForm() {
    this.table_row_form.hide();
    this._getTableRowFormOnlyUpdateModeVisibleElements().hide();
    this._getTableRowFormOnlyInsertModeVisibleElements().show();
    this._enableReadOnlyFieldsOfTableRowForm();
    this._resetStatusMessages();
    this._toggleTableRowFormDisplayButton();
    this._resetTableRowFormDefaultValues();
    this._initTableRowFormHeader();
    this._initTableRowFormSubmitButtonText();
  }

  _resetTableRowFormDefaultValues() {
    this._resetFormDefaultValues(this.table_row_form);
  }

  _initTableRowFormResetButton() {

    var table = this;

    this.table_row_form_reset_button.click(function () {
      table._resetTableRowForm();
    });
  };

  _initTableRowFormDefaultValues() {
    this._saveFormDefaultValues(this.table_row_form);
  }

  _initTableUpdateLinks() {

    var table = this;

    this.table_row_update_links.click(function (event) {
      event.preventDefault();
      $.ajax({
        url: table._addFilterUrlArgs($(this).attr('href')),
        type: 'post',
        dataType: 'json',
        success: table._processGetTableRowResult.bind(table)
      });
      return false;
    });
  }

  _processGetTableRowResult(result) {

    this._resetStatusMessages();

    if (!parseInt(result.status)) {
      this._processGetTableRowWrongResult(result);
      return;
    }

    this._processGetTableRowSuccessResult(result);
  }

  _processGetTableRowWrongResult(result) {

    if(result.hasOwnProperty('html')) {
      this._reinitDynamicBlock(result.html);
      return;
    }

    this._processWrongResult(result);
  }

  _processGetTableRowSuccessResult(result) {

    this._initTableRowFormHeader(false);
    this._initTableRowFormSubmitButtonText(false);

    this._loadTableRowToForm(result.data);
    this._disableReadOnlyFieldsOfTableRowForm();

    this._getTableRowFormOnlyUpdateModeVisibleElements().show();
    this._getTableRowFormOnlyInsertModeVisibleElements().hide();
    this.table_row_form.show();
    this._toggleTableRowFormDisplayButton();

    $.scrollTo(this.table_row_form);
  }

  _getTableRowFormOnlyUpdateModeVisibleElements() {
    return this.table_row_form.find('[data-visible_mode="update"]');
  }
  
  _getTableRowFormOnlyInsertModeVisibleElements() {
    return this.table_row_form.find('[data-visible_mode="insert"]');
  }

  _loadTableRowToForm(table_row_data) {

    var table_row_form = this.table_row_form;

    $.each(table_row_data, function(key, value) {

      var input_selector_by_name = '[name=' + key +']';

      let input_element = table_row_form.find(input_selector_by_name);

      let input_type = input_element.attr('type');

      if(input_type != 'radio' && input_type !='checkbox') {
        input_element.val(value);
        return;
      }

      let full_input_selector = input_selector_by_name + '[value=' + value + ']';
      let input_element_by_value = table_row_form.find(full_input_selector);
      input_element_by_value.attr('checked', true);
    });
  }

  _disableReadOnlyFieldsOfTableRowForm() {
    this._getTableRowFormOnlyUpdateModeDisabledElements().attr('disabled', true);
  };

  _getTableRowFormOnlyUpdateModeDisabledElements() {
    return this.table_row_form.find('[data-disable_mode="update"]');
  }

  _enableReadOnlyFieldsOfTableRowForm() {
    this._getTableRowFormOnlyUpdateModeDisabledElements().attr('disabled', false);
  };
}



/** WEBPACK FOOTER **
 ** ./src/common/table/updatable.js
 **/